import React, { useEffect } from 'react';
import { Text } from '@wix/design-system';
import { TextTyper } from '../TextTyper/TextTyper';
import { LoadingAssistantMessage } from '../ChatMessage/LoadingAssistantMessage/LoadingAssistantMessage';
import { StyledText } from '../TextTyper/StyledText';

type TextChatWidgetData = {
  text: string;
  onTypingEnd?: () => void;
  onTyping?: () => void;
  useTyper: boolean;
};

export type ButtonChatWidgetProps = {
  data: TextChatWidgetData;
};
export const TextChatWidget: React.FC<ButtonChatWidgetProps> = ({ data }) => {
  const isCallbackCalled = React.useRef(false);
  useEffect(() => {
    if (!data?.useTyper && !data?.text) {
      if (isCallbackCalled.current) {
        return;
      }
      isCallbackCalled.current = true;
      data?.onTyping?.();
      data?.onTypingEnd?.();
    }
  }, [data]);

  const text = data?.useTyper ? (
    data?.text ? (
      <TextTyper
        byLetter={true}
        text={data.text}
        onTypingEnd={data?.onTypingEnd}
        onTyping={data?.onTyping}
      />
    ) : (
      // TODO: is this even used?
      <LoadingAssistantMessage theme="original" />
    )
  ) : (
    data.text
  );

  return (
    <StyledText>
      <Text type="secondary">{text}</Text>
    </StyledText>
  );
};

export const TEXT_WIDGET = 'TEXT_WIDGET';
